import React, { createContext, useReducer, useMemo } from 'react';

const actions = {
    SET_USER: 'SET_USER',
    CLEAR_USER: 'CLEAR_USER'
};

const initialState = {
    user: null
};

function reducer(state, action) {
    switch (action.type) {
        case actions.SET_USER:
            return {
                ...state,
                user: action.payload
            };
        case actions.CLEAR_USER:
            return {
                ...state,
                user: null
            };
        default:
            return state;
    }
}

export const UserContext = createContext();

const UserContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const value = useMemo(() => ({
        user: state.user,
        setUser: (userData) => dispatch({ type: actions.SET_USER, payload: userData }),
        clearUser: () => dispatch({ type: actions.CLEAR_USER })
    }), [state]);

    return (
        <UserContext.Provider value={value}>
            {children}
        </UserContext.Provider>
    );
};

export default UserContextProvider;
